module.exports = __webpack_public_path__ + "img/run.5a59ca38.jpg";